import React from 'react';
import dynamic from 'next/dynamic';

const Banner = dynamic(() => import('../../Banner'), { ssr: false });

const BANNER_REPEAT_INTERVAL = 30;

interface ItemListBannerProps {
  currIndex: number;
  bannerStartIndex: number;
  isSmall: boolean;
}

export const ItemListBanner: React.FC<ItemListBannerProps> = ({
  currIndex,
  bannerStartIndex,
  isSmall
}) => {
  const isFirstBannerPosition = currIndex === bannerStartIndex;
  const isRepeatingBannerPosition =
    currIndex > bannerStartIndex &&
    (currIndex - bannerStartIndex) % BANNER_REPEAT_INTERVAL === 0;
  const isBannerPosition =
    isSmall && (isFirstBannerPosition || isRepeatingBannerPosition);

  return (
    <>
      {isSmall
        ? isBannerPosition && (
            <Banner
              tagName={'p'}
              containerClassName="lotriver-bottom-banner lotriver-search-banner content-banner"
              containerId={`js-lotriver-bottom-banner-${currIndex}`}
              sid={'220686'}
              bn={'6'}
              arCn={Number(currIndex)}
            />
          )
        : isFirstBannerPosition && (
            <Banner
              tagName={'p'}
              containerClassName={'lotriver-search-banner content-banner'}
              containerId={`js-lotriver-search-banner`}
              sid={'220686'}
              bn={'7'}
              arCn={Number(currIndex)}
            />
          )}
    </>
  );
};
